import { render, staticRenderFns } from "./SettingsMultiWhatsapp.vue?vue&type=template&id=5ca60998&scoped=true"
import script from "./SettingsMultiWhatsapp.vue?vue&type=script&lang=js"
export * from "./SettingsMultiWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./SettingsMultiWhatsapp.vue?vue&type=style&index=0&id=5ca60998&prod&lang=scss&scoped=true"
import style1 from "./SettingsMultiWhatsapp.vue?vue&type=style&index=1&id=5ca60998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca60998",
  null
  
)

export default component.exports